/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const COUNTRIES_SELECT_OPTIONS = [
  {
    id: 239,
    value: "US",
    label: "United States",
  },
  {
    id: 238,
    value: "GB",
    label: "United Kingdom",
  },
  {
    id: 76,
    value: "FR",
    label: "France",
  },
  {
    id: 231,
    value: "TR",
    label: "Turkey",
  },
  {
    id: 182,
    value: "QA",
    label: "Qatar",
  },
  {
    id: 1,
    value: "AF",
    label: "Afghanistan",
  },
  {
    id: 2,
    value: "AX",
    label: "Aland Islands",
  },
  {
    id: 3,
    value: "AL",
    label: "Albania",
  },
  {
    id: 4,
    value: "DZ",
    label: "Algeria",
  },
  {
    id: 5,
    value: "AS",
    label: "American Samoa",
  },
  {
    id: 6,
    value: "AD",
    label: "Andorra",
  },
  {
    id: 7,
    value: "AO",
    label: "Angola",
  },
  {
    id: 8,
    value: "AI",
    label: "Anguilla",
  },
  {
    id: 9,
    value: "AQ",
    label: "Antarctica",
  },
  {
    id: 10,
    value: "AG",
    label: "Antigua and Barbuda",
  },
  {
    id: 11,
    value: "AR",
    label: "Argentina",
  },
  {
    id: 12,
    value: "AM",
    label: "Armenia",
  },
  {
    id: 13,
    value: "AW",
    label: "Aruba",
  },
  {
    id: 14,
    value: "AU",
    label: "Australia",
  },
  {
    id: 15,
    value: "AT",
    label: "Austria",
  },
  {
    id: 16,
    value: "AZ",
    label: "Azerbaijan",
  },
  {
    id: 17,
    value: "BS",
    label: "Bahamas",
  },
  {
    id: 18,
    value: "BH",
    label: "Bahrain",
  },
  {
    id: 19,
    value: "BD",
    label: "Bangladesh",
  },
  {
    id: 20,
    value: "BB",
    label: "Barbados",
  },
  {
    id: 21,
    value: "BY",
    label: "Belarus",
  },
  {
    id: 22,
    value: "BE",
    label: "Belgium",
  },
  {
    id: 23,
    value: "BZ",
    label: "Belize",
  },
  {
    id: 24,
    value: "BJ",
    label: "Benin",
  },
  {
    id: 25,
    value: "BM",
    label: "Bermuda",
  },
  {
    id: 26,
    value: "BT",
    label: "Bhutan",
  },
  {
    id: 27,
    value: "BO",
    label: "Bolivia",
  },
  {
    id: 28,
    value: "BQ",
    label: "Bonaire, Sint Eustatius and Saba",
  },
  {
    id: 29,
    value: "BA",
    label: "Bosnia and Herzegovina",
  },
  {
    id: 30,
    value: "BW",
    label: "Botswana",
  },
  {
    id: 31,
    value: "BV",
    label: "Bouvet Island",
  },
  {
    id: 32,
    value: "BR",
    label: "Brazil",
  },
  {
    id: 33,
    value: "IO",
    label: "British Indian Ocean Territory",
  },
  {
    id: 34,
    value: "BN",
    label: "Brunei Darussalam",
  },
  {
    id: 35,
    value: "BG",
    label: "Bulgaria",
  },
  {
    id: 36,
    value: "BF",
    label: "Burkina Faso",
  },
  {
    id: 37,
    value: "BI",
    label: "Burundi",
  },
  {
    id: 38,
    value: "KH",
    label: "Cambodia",
  },
  {
    id: 39,
    value: "CM",
    label: "Cameroon",
  },
  {
    id: 40,
    value: "CA",
    label: "Canada",
  },
  {
    id: 41,
    value: "CV",
    label: "Cape Verde",
  },
  {
    id: 42,
    value: "KY",
    label: "Cayman Islands",
  },
  {
    id: 43,
    value: "CF",
    label: "Central African Republic",
  },
  {
    id: 44,
    value: "TD",
    label: "Chad",
  },
  {
    id: 45,
    value: "CL",
    label: "Chile",
  },
  {
    id: 46,
    value: "CN",
    label: "China",
  },
  {
    id: 47,
    value: "CX",
    label: "Christmas Island",
  },
  {
    id: 48,
    value: "CC",
    label: "Cocos (Keeling) Islands",
  },
  {
    id: 49,
    value: "CO",
    label: "Colombia",
  },
  {
    id: 50,
    value: "KM",
    label: "Comoros",
  },
  {
    id: 51,
    value: "CG",
    label: "Congo",
  },
  {
    id: 52,
    value: "CD",
    label: "Congo, Democratic Republic of the Congo",
  },
  {
    id: 53,
    value: "CK",
    label: "Cook Islands",
  },
  {
    id: 54,
    value: "CR",
    label: "Costa Rica",
  },
  {
    id: 55,
    value: "CI",
    label: "Cote D'Ivoire",
  },
  {
    id: 56,
    value: "HR",
    label: "Croatia",
  },
  {
    id: 57,
    value: "CU",
    label: "Cuba",
  },
  {
    id: 58,
    value: "CW",
    label: "Curacao",
  },
  {
    id: 59,
    value: "CY",
    label: "Cyprus",
  },
  {
    id: 60,
    value: "CZ",
    label: "Czech Republic",
  },
  {
    id: 61,
    value: "DK",
    label: "Denmark",
  },
  {
    id: 62,
    value: "DJ",
    label: "Djibouti",
  },
  {
    id: 63,
    value: "DM",
    label: "Dominica",
  },
  {
    id: 64,
    value: "DO",
    label: "Dominican Republic",
  },
  {
    id: 65,
    value: "EC",
    label: "Ecuador",
  },
  {
    id: 66,
    value: "EG",
    label: "Egypt",
  },
  {
    id: 67,
    value: "SV",
    label: "El Salvador",
  },
  {
    id: 68,
    value: "GQ",
    label: "Equatorial Guinea",
  },
  {
    id: 69,
    value: "ER",
    label: "Eritrea",
  },
  {
    id: 70,
    value: "EE",
    label: "Estonia",
  },
  {
    id: 71,
    value: "ET",
    label: "Ethiopia",
  },
  {
    id: 72,
    value: "FK",
    label: "Falkland Islands (Malvinas)",
  },
  {
    id: 73,
    value: "FO",
    label: "Faroe Islands",
  },
  {
    id: 74,
    value: "FJ",
    label: "Fiji",
  },
  {
    id: 75,
    value: "FI",
    label: "Finland",
  },

  {
    id: 77,
    value: "GF",
    label: "French Guiana",
  },
  {
    id: 78,
    value: "PF",
    label: "French Polynesia",
  },
  {
    id: 79,
    value: "TF",
    label: "French Southern Territories",
  },
  {
    id: 80,
    value: "GA",
    label: "Gabon",
  },
  {
    id: 81,
    value: "GM",
    label: "Gambia",
  },
  {
    id: 82,
    value: "GE",
    label: "Georgia",
  },
  {
    id: 83,
    value: "DE",
    label: "Germany",
  },
  {
    id: 84,
    value: "GH",
    label: "Ghana",
  },
  {
    id: 85,
    value: "GI",
    label: "Gibraltar",
  },
  {
    id: 86,
    value: "GR",
    label: "Greece",
  },
  {
    id: 87,
    value: "GL",
    label: "Greenland",
  },
  {
    id: 88,
    value: "GD",
    label: "Grenada",
  },
  {
    id: 89,
    value: "GP",
    label: "Guadeloupe",
  },
  {
    id: 90,
    value: "GU",
    label: "Guam",
  },
  {
    id: 91,
    value: "GT",
    label: "Guatemala",
  },
  {
    id: 92,
    value: "GG",
    label: "Guernsey",
  },
  {
    id: 93,
    value: "GN",
    label: "Guinea",
  },
  {
    id: 94,
    value: "GW",
    label: "Guinea-Bissau",
  },
  {
    id: 95,
    value: "GY",
    label: "Guyana",
  },
  {
    id: 96,
    value: "HT",
    label: "Haiti",
  },
  {
    id: 97,
    value: "HM",
    label: "Heard Island and Mcdonald Islands",
  },
  {
    id: 98,
    value: "VA",
    label: "Holy See (Vatican City State)",
  },
  {
    id: 99,
    value: "HN",
    label: "Honduras",
  },
  {
    id: 100,
    value: "HK",
    label: "Hong Kong",
  },
  {
    id: 101,
    value: "HU",
    label: "Hungary",
  },
  {
    id: 102,
    value: "IS",
    label: "Iceland",
  },
  {
    id: 103,
    value: "IN",
    label: "India",
  },
  {
    id: 104,
    value: "ID",
    label: "Indonesia",
  },
  {
    id: 105,
    value: "IR",
    label: "Iran, Islamic Republic of",
  },
  {
    id: 106,
    value: "IQ",
    label: "Iraq",
  },
  {
    id: 107,
    value: "IE",
    label: "Ireland",
  },
  {
    id: 108,
    value: "IM",
    label: "Isle of Man",
  },
  {
    id: 109,
    value: "IL",
    label: "Israel",
  },
  {
    id: 110,
    value: "IT",
    label: "Italy",
  },
  {
    id: 111,
    value: "JM",
    label: "Jamaica",
  },
  {
    id: 112,
    value: "JP",
    label: "Japan",
  },
  {
    id: 113,
    value: "JE",
    label: "Jersey",
  },
  {
    id: 114,
    value: "JO",
    label: "Jordan",
  },
  {
    id: 115,
    value: "KZ",
    label: "Kazakhstan",
  },
  {
    id: 116,
    value: "KE",
    label: "Kenya",
  },
  {
    id: 117,
    value: "KI",
    label: "Kiribati",
  },
  {
    id: 118,
    value: "KP",
    label: "Korea, Democratic People's Republic of",
  },
  {
    id: 119,
    value: "KR",
    label: "Korea, Republic of",
  },
  {
    id: 120,
    value: "XK",
    label: "Kosovo",
  },
  {
    id: 121,
    value: "KW",
    label: "Kuwait",
  },
  {
    id: 122,
    value: "KG",
    label: "Kyrgyzstan",
  },
  {
    id: 123,
    value: "LA",
    label: "Lao People's Democratic Republic",
  },
  {
    id: 124,
    value: "LV",
    label: "Latvia",
  },
  {
    id: 125,
    value: "LB",
    label: "Lebanon",
  },
  {
    id: 126,
    value: "LS",
    label: "Lesotho",
  },
  {
    id: 127,
    value: "LR",
    label: "Liberia",
  },
  {
    id: 128,
    value: "LY",
    label: "Libyan Arab Jamahiriya",
  },
  {
    id: 129,
    value: "LI",
    label: "Liechtenstein",
  },
  {
    id: 130,
    value: "LT",
    label: "Lithuania",
  },
  {
    id: 131,
    value: "LU",
    label: "Luxembourg",
  },
  {
    id: 132,
    value: "MO",
    label: "Macao",
  },
  {
    id: 133,
    value: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
  },
  {
    id: 134,
    value: "MG",
    label: "Madagascar",
  },
  {
    id: 135,
    value: "MW",
    label: "Malawi",
  },
  {
    id: 136,
    value: "MY",
    label: "Malaysia",
  },
  {
    id: 137,
    value: "MV",
    label: "Maldives",
  },
  {
    id: 138,
    value: "ML",
    label: "Mali",
  },
  {
    id: 139,
    value: "MT",
    label: "Malta",
  },
  {
    id: 140,
    value: "MH",
    label: "Marshall Islands",
  },
  {
    id: 141,
    value: "MQ",
    label: "Martinique",
  },
  {
    id: 142,
    value: "MR",
    label: "Mauritania",
  },
  {
    id: 143,
    value: "MU",
    label: "Mauritius",
  },
  {
    id: 144,
    value: "YT",
    label: "Mayotte",
  },
  {
    id: 145,
    value: "MX",
    label: "Mexico",
  },
  {
    id: 146,
    value: "FM",
    label: "Micronesia, Federated States of",
  },
  {
    id: 147,
    value: "MD",
    label: "Moldova, Republic of",
  },
  {
    id: 148,
    value: "MC",
    label: "Monaco",
  },
  {
    id: 149,
    value: "MN",
    label: "Mongolia",
  },
  {
    id: 150,
    value: "ME",
    label: "Montenegro",
  },
  {
    id: 151,
    value: "MS",
    label: "Montserrat",
  },
  {
    id: 152,
    value: "MA",
    label: "Morocco",
  },
  {
    id: 153,
    value: "MZ",
    label: "Mozambique",
  },
  {
    id: 154,
    value: "MM",
    label: "Myanmar",
  },
  {
    id: 155,
    value: "NA",
    label: "Namibia",
  },
  {
    id: 156,
    value: "NR",
    label: "Nauru",
  },
  {
    id: 157,
    value: "NP",
    label: "Nepal",
  },
  {
    id: 158,
    value: "NL",
    label: "Netherlands",
  },
  {
    id: 159,
    value: "AN",
    label: "Netherlands Antilles",
  },
  {
    id: 160,
    value: "NC",
    label: "New Caledonia",
  },
  {
    id: 161,
    value: "NZ",
    label: "New Zealand",
  },
  {
    id: 162,
    value: "NI",
    label: "Nicaragua",
  },
  {
    id: 163,
    value: "NE",
    label: "Niger",
  },
  {
    id: 164,
    value: "NG",
    label: "Nigeria",
  },
  {
    id: 165,
    value: "NU",
    label: "Niue",
  },
  {
    id: 166,
    value: "NF",
    label: "Norfolk Island",
  },
  {
    id: 167,
    value: "MP",
    label: "Northern Mariana Islands",
  },
  {
    id: 168,
    value: "NO",
    label: "Norway",
  },
  {
    id: 169,
    value: "OM",
    label: "Oman",
  },
  {
    id: 170,
    value: "PK",
    label: "Pakistan",
  },
  {
    id: 171,
    value: "PW",
    label: "Palau",
  },
  {
    id: 172,
    value: "PS",
    label: "Palestinian Territory, Occupied",
  },
  {
    id: 173,
    value: "PA",
    label: "Panama",
  },
  {
    id: 174,
    value: "PG",
    label: "Papua New Guinea",
  },
  {
    id: 175,
    value: "PY",
    label: "Paraguay",
  },
  {
    id: 176,
    value: "PE",
    label: "Peru",
  },
  {
    id: 177,
    value: "PH",
    label: "Philippines",
  },
  {
    id: 178,
    value: "PN",
    label: "Pitcairn",
  },
  {
    id: 179,
    value: "PL",
    label: "Poland",
  },
  {
    id: 180,
    value: "PT",
    label: "Portugal",
  },
  {
    id: 181,
    value: "PR",
    label: "Puerto Rico",
  },

  {
    id: 183,
    value: "RE",
    label: "Reunion",
  },
  {
    id: 184,
    value: "RO",
    label: "Romania",
  },
  {
    id: 185,
    value: "RU",
    label: "Russian Federation",
  },
  {
    id: 186,
    value: "RW",
    label: "Rwanda",
  },
  {
    id: 187,
    value: "BL",
    label: "Saint Barthelemy",
  },
  {
    id: 188,
    value: "SH",
    label: "Saint Helena",
  },
  {
    id: 189,
    value: "KN",
    label: "Saint Kitts and Nevis",
  },
  {
    id: 190,
    value: "LC",
    label: "Saint Lucia",
  },
  {
    id: 191,
    value: "MF",
    label: "Saint Martin",
  },
  {
    id: 192,
    value: "PM",
    label: "Saint Pierre and Miquelon",
  },
  {
    id: 193,
    value: "VC",
    label: "Saint Vincent and the Grenadines",
  },
  {
    id: 194,
    value: "WS",
    label: "Samoa",
  },
  {
    id: 195,
    value: "SM",
    label: "San Marino",
  },
  {
    id: 196,
    value: "ST",
    label: "Sao Tome and Principe",
  },
  {
    id: 197,
    value: "SA",
    label: "Saudi Arabia",
  },
  {
    id: 198,
    value: "SN",
    label: "Senegal",
  },
  {
    id: 199,
    value: "RS",
    label: "Serbia",
  },
  {
    id: 200,
    value: "CS",
    label: "Serbia and Montenegro",
  },
  {
    id: 201,
    value: "SC",
    label: "Seychelles",
  },
  {
    id: 202,
    value: "SL",
    label: "Sierra Leone",
  },
  {
    id: 203,
    value: "SG",
    label: "Singapore",
  },
  {
    id: 204,
    value: "SX",
    label: "Sint Maarten",
  },
  {
    id: 205,
    value: "SK",
    label: "Slovakia",
  },
  {
    id: 206,
    value: "SI",
    label: "Slovenia",
  },
  {
    id: 207,
    value: "SB",
    label: "Solomon Islands",
  },
  {
    id: 208,
    value: "SO",
    label: "Somalia",
  },
  {
    id: 209,
    value: "ZA",
    label: "South Africa",
  },
  {
    id: 210,
    value: "GS",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    id: 211,
    value: "SS",
    label: "South Sudan",
  },
  {
    id: 212,
    value: "ES",
    label: "Spain",
  },
  {
    id: 213,
    value: "LK",
    label: "Sri Lanka",
  },
  {
    id: 214,
    value: "SD",
    label: "Sudan",
  },
  {
    id: 215,
    value: "SR",
    label: "Suriname",
  },
  {
    id: 216,
    value: "SJ",
    label: "Svalbard and Jan Mayen",
  },
  {
    id: 217,
    value: "SZ",
    label: "Swaziland",
  },
  {
    id: 218,
    value: "SE",
    label: "Sweden",
  },
  {
    id: 219,
    value: "CH",
    label: "Switzerland",
  },
  {
    id: 220,
    value: "SY",
    label: "Syrian Arab Republic",
  },
  {
    id: 221,
    value: "TW",
    label: "Taiwan, Province of China",
  },
  {
    id: 222,
    value: "TJ",
    label: "Tajikistan",
  },
  {
    id: 223,
    value: "TZ",
    label: "Tanzania, United Republic of",
  },
  {
    id: 224,
    value: "TH",
    label: "Thailand",
  },
  {
    id: 225,
    value: "TL",
    label: "Timor-Leste",
  },
  {
    id: 226,
    value: "TG",
    label: "Togo",
  },
  {
    id: 227,
    value: "TK",
    label: "Tokelau",
  },
  {
    id: 228,
    value: "TO",
    label: "Tonga",
  },
  {
    id: 229,
    value: "TT",
    label: "Trinidad and Tobago",
  },
  {
    id: 230,
    value: "TN",
    label: "Tunisia",
  },

  {
    id: 232,
    value: "TM",
    label: "Turkmenistan",
  },
  {
    id: 233,
    value: "TC",
    label: "Turks and Caicos Islands",
  },
  {
    id: 234,
    value: "TV",
    label: "Tuvalu",
  },
  {
    id: 235,
    value: "UG",
    label: "Uganda",
  },
  {
    id: 236,
    value: "UA",
    label: "Ukraine",
  },
  {
    id: 237,
    value: "AE",
    label: "United Arab Emirates",
  },

  {
    id: 240,
    value: "UM",
    label: "United States Minor Outlying Islands",
  },
  {
    id: 241,
    value: "UY",
    label: "Uruguay",
  },
  {
    id: 242,
    value: "UZ",
    label: "Uzbekistan",
  },
  {
    id: 243,
    value: "VU",
    label: "Vanuatu",
  },
  {
    id: 244,
    value: "VE",
    label: "Venezuela",
  },
  {
    id: 245,
    value: "VN",
    label: "Viet Nam",
  },
  {
    id: 246,
    value: "VG",
    label: "Virgin Islands, British",
  },
  {
    id: 247,
    value: "VI",
    label: "Virgin Islands, U.s.",
  },
  {
    id: 248,
    value: "WF",
    label: "Wallis and Futuna",
  },
  {
    id: 249,
    value: "EH",
    label: "Western Sahara",
  },
  {
    id: 250,
    value: "YE",
    label: "Yemen",
  },
  {
    id: 251,
    value: "ZM",
    label: "Zambia",
  },
  {
    id: 252,
    value: "ZW",
    label: "Zimbabwe",
  },
];

export const ISO_COUNTRIES = [
  {
    id: 239,
    value: "US",
    label: "US",
  },
  {
    id: 238,
    value: "GB",
    label: "GB",
  },
  {
    id: 76,
    value: "FR",
    label: "FR",
  },
  {
    id: 231,
    value: "TR",
    label: "TR",
  },
  {
    id: 182,
    value: "QA",
    label: "QA",
  },
  {
    id: 1,
    value: "AF",
    label: "AF",
  },
  {
    id: 2,
    value: "AX",
    label: "AX",
  },
  {
    id: 3,
    value: "AL",
    label: "AL",
  },
  {
    id: 4,
    value: "DZ",
    label: "DZ",
  },
  {
    id: 5,
    value: "AS",
    label: "AS",
  },
  {
    id: 6,
    value: "AD",
    label: "AD",
  },
  {
    id: 7,
    value: "AO",
    label: "AO",
  },
  {
    id: 8,
    value: "AI",
    label: "AI",
  },
  {
    id: 9,
    value: "AQ",
    label: "AQ",
  },
  {
    id: 10,
    value: "AG",
    label: "AG",
  },
  {
    id: 11,
    value: "AR",
    label: "AR",
  },
  {
    id: 12,
    value: "AM",
    label: "AM",
  },
  {
    id: 13,
    value: "AW",
    label: "AW",
  },
  {
    id: 14,
    value: "AU",
    label: "AU",
  },
  {
    id: 15,
    value: "AT",
    label: "AT",
  },
  {
    id: 16,
    value: "AZ",
    label: "AZ",
  },
  {
    id: 17,
    value: "BS",
    label: "BS",
  },
  {
    id: 18,
    value: "BH",
    label: "BH",
  },
  {
    id: 19,
    value: "BD",
    label: "BD",
  },
  {
    id: 20,
    value: "BB",
    label: "BB",
  },
  {
    id: 21,
    value: "BY",
    label: "BY",
  },
  {
    id: 22,
    value: "BE",
    label: "BE",
  },
  {
    id: 23,
    value: "BZ",
    label: "BZ",
  },
  {
    id: 24,
    value: "BJ",
    label: "BJ",
  },
  {
    id: 25,
    value: "BM",
    label: "BM",
  },
  {
    id: 26,
    value: "BT",
    label: "BT",
  },
  {
    id: 27,
    value: "BO",
    label: "BO",
  },
  {
    id: 28,
    value: "BQ",
    label: "BQ",
  },
  {
    id: 29,
    value: "BA",
    label: "BA",
  },
  {
    id: 30,
    value: "BW",
    label: "BW",
  },
  {
    id: 31,
    value: "BV",
    label: "BV",
  },
  {
    id: 32,
    value: "BR",
    label: "BR",
  },
  {
    id: 33,
    value: "IO",
    label: "IO",
  },
  {
    id: 34,
    value: "BN",
    label: "BN",
  },
  {
    id: 35,
    value: "BG",
    label: "BG",
  },
  {
    id: 36,
    value: "BF",
    label: "BF",
  },
  {
    id: 37,
    value: "BI",
    label: "BI",
  },
  {
    id: 38,
    value: "KH",
    label: "KH",
  },
  {
    id: 39,
    value: "CM",
    label: "CM",
  },
  {
    id: 40,
    value: "CA",
    label: "CA",
  },
  {
    id: 41,
    value: "CV",
    label: "CV",
  },
  {
    id: 42,
    value: "KY",
    label: "KY",
  },
  {
    id: 43,
    value: "CF",
    label: "CF",
  },
  {
    id: 44,
    value: "TD",
    label: "TD",
  },
  {
    id: 45,
    value: "CL",
    label: "CL",
  },
  {
    id: 46,
    value: "CN",
    label: "CN",
  },
  {
    id: 47,
    value: "CX",
    label: "CX",
  },
  {
    id: 48,
    value: "CC",
    label: "CC",
  },
  {
    id: 49,
    value: "CO",
    label: "CO",
  },
  {
    id: 50,
    value: "KM",
    label: "KM",
  },
  {
    id: 51,
    value: "CG",
    label: "CG",
  },
  {
    id: 52,
    value: "CD",
    label: "CD",
  },
  {
    id: 53,
    value: "CK",
    label: "CK",
  },
  {
    id: 54,
    value: "CR",
    label: "CR",
  },
  {
    id: 55,
    value: "CI",
    label: "CI",
  },
  {
    id: 56,
    value: "HR",
    label: "HR",
  },
  {
    id: 57,
    value: "CU",
    label: "CU",
  },
  {
    id: 58,
    value: "CW",
    label: "CW",
  },
  {
    id: 59,
    value: "CY",
    label: "CY",
  },
  {
    id: 60,
    value: "CZ",
    label: "CZ",
  },
  {
    id: 61,
    value: "DK",
    label: "DK",
  },
  {
    id: 62,
    value: "DJ",
    label: "DJ",
  },
  {
    id: 63,
    value: "DM",
    label: "DM",
  },
  {
    id: 64,
    value: "DO",
    label: "DO",
  },
  {
    id: 65,
    value: "EC",
    label: "EC",
  },
  {
    id: 66,
    value: "EG",
    label: "EG",
  },
  {
    id: 67,
    value: "SV",
    label: "SV",
  },
  {
    id: 68,
    value: "GQ",
    label: "GQ",
  },
  {
    id: 69,
    value: "ER",
    label: "ER",
  },
  {
    id: 70,
    value: "EE",
    label: "EE",
  },
  {
    id: 71,
    value: "ET",
    label: "ET",
  },
  {
    id: 72,
    value: "FK",
    label: "FK",
  },
  {
    id: 73,
    value: "FO",
    label: "FO",
  },
  {
    id: 74,
    value: "FJ",
    label: "FJ",
  },
  {
    id: 75,
    value: "FI",
    label: "FI",
  },

  {
    id: 77,
    value: "GF",
    label: "GF",
  },
  {
    id: 78,
    value: "PF",
    label: "PF",
  },
  {
    id: 79,
    value: "TF",
    label: "TF",
  },
  {
    id: 80,
    value: "GA",
    label: "GA",
  },
  {
    id: 81,
    value: "GM",
    label: "GM",
  },
  {
    id: 82,
    value: "GE",
    label: "GE",
  },
  {
    id: 83,
    value: "DE",
    label: "DE",
  },
  {
    id: 84,
    value: "GH",
    label: "GH",
  },
  {
    id: 85,
    value: "GI",
    label: "GI",
  },
  {
    id: 86,
    value: "GR",
    label: "GR",
  },
  {
    id: 87,
    value: "GL",
    label: "GL",
  },
  {
    id: 88,
    value: "GD",
    label: "GD",
  },
  {
    id: 89,
    value: "GP",
    label: "GP",
  },
  {
    id: 90,
    value: "GU",
    label: "GU",
  },
  {
    id: 91,
    value: "GT",
    label: "GT",
  },
  {
    id: 92,
    value: "GG",
    label: "GG",
  },
  {
    id: 93,
    value: "GN",
    label: "GN",
  },
  {
    id: 94,
    value: "GW",
    label: "GW",
  },
  {
    id: 95,
    value: "GY",
    label: "GY",
  },
  {
    id: 96,
    value: "HT",
    label: "HT",
  },
  {
    id: 97,
    value: "HM",
    label: "HM",
  },
  {
    id: 98,
    value: "VA",
    label: "VA",
  },
  {
    id: 99,
    value: "HN",
    label: "HN",
  },
  {
    id: 100,
    value: "HK",
    label: "HK",
  },
  {
    id: 101,
    value: "HU",
    label: "HU",
  },
  {
    id: 102,
    value: "IS",
    label: "IS",
  },
  {
    id: 103,
    value: "IN",
    label: "IN",
  },
  {
    id: 104,
    value: "ID",
    label: "ID",
  },
  {
    id: 105,
    value: "IR",
    label: "IR",
  },
  {
    id: 106,
    value: "IQ",
    label: "IQ",
  },
  {
    id: 107,
    value: "IE",
    label: "IE",
  },
  {
    id: 108,
    value: "IM",
    label: "IM",
  },
  {
    id: 109,
    value: "IL",
    label: "IL",
  },
  {
    id: 110,
    value: "IT",
    label: "IT",
  },
  {
    id: 111,
    value: "JM",
    label: "JM",
  },
  {
    id: 112,
    value: "JP",
    label: "JP",
  },
  {
    id: 113,
    value: "JE",
    label: "JE",
  },
  {
    id: 114,
    value: "JO",
    label: "JO",
  },
  {
    id: 115,
    value: "KZ",
    label: "KZ",
  },
  {
    id: 116,
    value: "KE",
    label: "KE",
  },
  {
    id: 117,
    value: "KI",
    label: "KI",
  },
  {
    id: 118,
    value: "KP",
    label: "KP",
  },
  {
    id: 119,
    value: "KR",
    label: "KR",
  },
  {
    id: 120,
    value: "XK",
    label: "XK",
  },
  {
    id: 121,
    value: "KW",
    label: "KW",
  },
  {
    id: 122,
    value: "KG",
    label: "KG",
  },
  {
    id: 123,
    value: "LA",
    label: "LA",
  },
  {
    id: 124,
    value: "LV",
    label: "LV",
  },
  {
    id: 125,
    value: "LB",
    label: "LB",
  },
  {
    id: 126,
    value: "LS",
    label: "LS",
  },
  {
    id: 127,
    value: "LR",
    label: "LR",
  },
  {
    id: 128,
    value: "LY",
    label: "LY",
  },
  {
    id: 129,
    value: "LI",
    label: "LI",
  },
  {
    id: 130,
    value: "LT",
    label: "LT",
  },
  {
    id: 131,
    value: "LU",
    label: "LU",
  },
  {
    id: 132,
    value: "MO",
    label: "MO",
  },
  {
    id: 133,
    value: "MK",
    label: "MK",
  },
  {
    id: 134,
    value: "MG",
    label: "MG",
  },
  {
    id: 135,
    value: "MW",
    label: "MW",
  },
  {
    id: 136,
    value: "MY",
    label: "MY",
  },
  {
    id: 137,
    value: "MV",
    label: "MV",
  },
  {
    id: 138,
    value: "ML",
    label: "ML",
  },
  {
    id: 139,
    value: "MT",
    label: "MT",
  },
  {
    id: 140,
    value: "MH",
    label: "MH",
  },
  {
    id: 141,
    value: "MQ",
    label: "MQ",
  },
  {
    id: 142,
    value: "MR",
    label: "MR",
  },
  {
    id: 143,
    value: "MU",
    label: "MU",
  },
  {
    id: 144,
    value: "YT",
    label: "YT",
  },
  {
    id: 145,
    value: "MX",
    label: "MX",
  },
  {
    id: 146,
    value: "FM",
    label: "FM",
  },
  {
    id: 147,
    value: "MD",
    label: "MD",
  },
  {
    id: 148,
    value: "MC",
    label: "MC",
  },
  {
    id: 149,
    value: "MN",
    label: "MN",
  },
  {
    id: 150,
    value: "ME",
    label: "ME",
  },
  {
    id: 151,
    value: "MS",
    label: "MS",
  },
  {
    id: 152,
    value: "MA",
    label: "MA",
  },
  {
    id: 153,
    value: "MZ",
    label: "MZ",
  },
  {
    id: 154,
    value: "MM",
    label: "MM",
  },
  {
    id: 155,
    value: "NA",
    label: "NA",
  },
  {
    id: 156,
    value: "NR",
    label: "NR",
  },
  {
    id: 157,
    value: "NP",
    label: "NP",
  },
  {
    id: 158,
    value: "NL",
    label: "NL",
  },
  {
    id: 159,
    value: "AN",
    label: "AN",
  },
  {
    id: 160,
    value: "NC",
    label: "NC",
  },
  {
    id: 161,
    value: "NZ",
    label: "NZ",
  },
  {
    id: 162,
    value: "NI",
    label: "NI",
  },
  {
    id: 163,
    value: "NE",
    label: "NE",
  },
  {
    id: 164,
    value: "NG",
    label: "NG",
  },
  {
    id: 165,
    value: "NU",
    label: "NU",
  },
  {
    id: 166,
    value: "NF",
    label: "NF",
  },
  {
    id: 167,
    value: "MP",
    label: "MP",
  },
  {
    id: 168,
    value: "NO",
    label: "NO",
  },
  {
    id: 169,
    value: "OM",
    label: "OM",
  },
  {
    id: 170,
    value: "PK",
    label: "PK",
  },
  {
    id: 171,
    value: "PW",
    label: "PW",
  },
  {
    id: 172,
    value: "PS",
    label: "PS",
  },
  {
    id: 173,
    value: "PA",
    label: "PA",
  },
  {
    id: 174,
    value: "PG",
    label: "PG",
  },
  {
    id: 175,
    value: "PY",
    label: "PY",
  },
  {
    id: 176,
    value: "PE",
    label: "PE",
  },
  {
    id: 177,
    value: "PH",
    label: "PH",
  },
  {
    id: 178,
    value: "PN",
    label: "PN",
  },
  {
    id: 179,
    value: "PL",
    label: "PL",
  },
  {
    id: 180,
    value: "PT",
    label: "PT",
  },
  {
    id: 181,
    value: "PR",
    label: "PR",
  },

  {
    id: 183,
    value: "RE",
    label: "RE",
  },
  {
    id: 184,
    value: "RO",
    label: "RO",
  },
  {
    id: 185,
    value: "RU",
    label: "RU",
  },
  {
    id: 186,
    value: "RW",
    label: "RW",
  },
  {
    id: 187,
    value: "BL",
    label: "BL",
  },
  {
    id: 188,
    value: "SH",
    label: "SH",
  },
  {
    id: 189,
    value: "KN",
    label: "KN",
  },
  {
    id: 190,
    value: "LC",
    label: "LC",
  },
  {
    id: 191,
    value: "MF",
    label: "MF",
  },
  {
    id: 192,
    value: "PM",
    label: "PM",
  },
  {
    id: 193,
    value: "VC",
    label: "VC",
  },
  {
    id: 194,
    value: "WS",
    label: "WS",
  },
  {
    id: 195,
    value: "SM",
    label: "SM",
  },
  {
    id: 196,
    value: "ST",
    label: "ST",
  },
  {
    id: 197,
    value: "SA",
    label: "SA",
  },
  {
    id: 198,
    value: "SN",
    label: "SN",
  },
  {
    id: 199,
    value: "RS",
    label: "RS",
  },
  {
    id: 200,
    value: "CS",
    label: "CS",
  },
  {
    id: 201,
    value: "SC",
    label: "SC",
  },
  {
    id: 202,
    value: "SL",
    label: "SL",
  },
  {
    id: 203,
    value: "SG",
    label: "SG",
  },
  {
    id: 204,
    value: "SX",
    label: "SX",
  },
  {
    id: 205,
    value: "SK",
    label: "SK",
  },
  {
    id: 206,
    value: "SI",
    label: "SI",
  },
  {
    id: 207,
    value: "SB",
    label: "SB",
  },
  {
    id: 208,
    value: "SO",
    label: "SO",
  },
  {
    id: 209,
    value: "ZA",
    label: "ZA",
  },
  {
    id: 210,
    value: "GS",
    label: "GS",
  },
  {
    id: 211,
    value: "SS",
    label: "SS",
  },
  {
    id: 212,
    value: "ES",
    label: "ES",
  },
  {
    id: 213,
    value: "LK",
    label: "LK",
  },
  {
    id: 214,
    value: "SD",
    label: "SD",
  },
  {
    id: 215,
    value: "SR",
    label: "SR",
  },
  {
    id: 216,
    value: "SJ",
    label: "SJ",
  },
  {
    id: 217,
    value: "SZ",
    label: "SZ",
  },
  {
    id: 218,
    value: "SE",
    label: "SE",
  },
  {
    id: 219,
    value: "CH",
    label: "CH",
  },
  {
    id: 220,
    value: "SY",
    label: "SY",
  },
  {
    id: 221,
    value: "TW",
    label: "TW",
  },
  {
    id: 222,
    value: "TJ",
    label: "TJ",
  },
  {
    id: 223,
    value: "TZ",
    label: "TZ",
  },
  {
    id: 224,
    value: "TH",
    label: "TH",
  },
  {
    id: 225,
    value: "TL",
    label: "TL",
  },
  {
    id: 226,
    value: "TG",
    label: "TG",
  },
  {
    id: 227,
    value: "TK",
    label: "TK",
  },
  {
    id: 228,
    value: "TO",
    label: "TO",
  },
  {
    id: 229,
    value: "TT",
    label: "TT",
  },
  {
    id: 230,
    value: "TN",
    label: "TN",
  },

  {
    id: 232,
    value: "TM",
    label: "TM",
  },
  {
    id: 233,
    value: "TC",
    label: "TC",
  },
  {
    id: 234,
    value: "TV",
    label: "TV",
  },
  {
    id: 235,
    value: "UG",
    label: "UG",
  },
  {
    id: 236,
    value: "UA",
    label: "UA",
  },
  {
    id: 237,
    value: "AE",
    label: "AE",
  },

  {
    id: 240,
    value: "UM",
    label: "UM",
  },
  {
    id: 241,
    value: "UY",
    label: "UY",
  },
  {
    id: 242,
    value: "UZ",
    label: "UZ",
  },
  {
    id: 243,
    value: "VU",
    label: "VU",
  },
  {
    id: 244,
    value: "VE",
    label: "VE",
  },
  {
    id: 245,
    value: "VN",
    label: "VN",
  },
  {
    id: 246,
    value: "VG",
    label: "VG",
  },
  {
    id: 247,
    value: "VI",
    label: "VI",
  },
  {
    id: 248,
    value: "WF",
    label: "WF",
  },
  {
    id: 249,
    value: "EH",
    label: "EH",
  },
  {
    id: 250,
    value: "YE",
    label: "YE",
  },
  {
    id: 251,
    value: "ZM",
    label: "ZM",
  },
  {
    id: 252,
    value: "ZW",
    label: "ZW",
  },
];

export const ARABIC_COUNTRIES_CODES = [
  "DZ",
  "BH",
  "EG",
  "IQ",
  "IR",
  "JO",
  "KW",
  "LB",
  "LY",
  "MR",
  "MA",
  "OM",
  "PS",
  "QA",
  "SA",
  "SD",
  "SY",
  "TN",
  "AE",
  "YE",
];

export const ARABIC_COUNTRIES = [
  "Algeria",
  "Bahrain",
  "Egypt",
  "Iraq",
  "Iran",
  "Jordan",
  "Kuwait",
  "Lebanon",
  "Libya",
  "Mauritania",
  "Morocco",
  "Oman",
  "Palestine",
  "Qatar",
  "Saudi Arabia",
  "Sudan",
  "Syrian Arab Republic",
  "Tunisia",
  "United Arab Emirates",
  "Yemen",
];

export const ENGLISH_COUNTRIES = [
  "Australia",
  "New Zealand",
  "United States",
  "United Kingdom",
];

export const ENGLISH_COUNTRIES_CODES = ["AU", "NZ", "US", "GB"];

export default COUNTRIES_SELECT_OPTIONS;
